import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2, SearchX } from "lucide-react";
import { api } from "@/lib/api";
import { PublicHeader } from "@/components/PublicHeader";
import { Seo } from "@/components/Seo";

// Permanent QR resolver: /q/:public_id -> current /pro/:slug (survives slug/name/org edits).
export default function QrResolver() {
  const { publicId } = useParams();
  const nav = useNavigate();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get(`/public/q/${encodeURIComponent(publicId)}`)
      .then((r) => { if (alive) nav(`/pro/${r.data.slug}`, { replace: true }); })
      .catch(() => { if (alive) setFailed(true); });
    return () => { alive = false; };
  }, [publicId, nav]);

  if (failed) {
    return (
      <div className="min-h-screen bg-white">
        <PublicHeader />
        <div className="max-w-md mx-auto text-center py-24 px-6" data-testid="qr-not-found">
          <SearchX className="h-12 w-12 text-slate-300 mx-auto" />
          <h1 className="font-display text-2xl font-bold text-[#0F2C59] mt-4">Profile not available</h1>
          <p className="text-slate-500 mt-2 text-sm">This PropertyConnect professional profile is no longer available or has not been published.</p>
          <button onClick={() => nav("/marketplace")} className="mt-6 h-11 px-5 rounded-xl bg-[#C79A3B] text-white font-semibold" data-testid="qr-explore-btn">Explore the Marketplace</button>
        </div>
      </div>
    );
  }
  return (
    <div className="min-h-screen bg-white flex items-center justify-center" data-testid="qr-resolving">
      <Seo robots="noindex,follow" />
      <div className="text-center">
        <Loader2 className="h-7 w-7 animate-spin text-[#C79A3B] mx-auto" />
        <p className="text-slate-500 mt-3 text-sm">Opening PropertyConnect professional profile…</p>
      </div>
    </div>
  );
}
